import { setState } from '../analytics-state.js';
export const ddoReady = () => {
  window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('ddo.ready', function () {
    setState({
      ddoReady: true
    });
  });
};
//# sourceMappingURL=digital-data.listener.analytics.js.map